import { Player } from "../Player";
import PlayerState, { PlayerStateTypes } from "./PlayerState"

export default class PlayerStateSmashFail extends PlayerState {
    flag: boolean
    constructor(player: Player, imgPrefix: string) {
        super(player, imgPrefix, PlayerStateTypes.SmashFail);
        this.flag = false;
    }

    beginState(): void {
        if (!this.flag) {
            super.beginState();
            this.startTimer(0.5);
            this.flag = true

            const anim = this.player.scene.add.spine(0, 0, "wall-smash-splat", "wall-fail", false);
            anim.scale = 0.5;
            this.player.bgSpineContainer.add(anim);

            this.scene.tweens.add({
                targets: this.player.glow,
                alpha: 0,
                scale: 0,
                duration: 300,
            });
        }
    }

    shutDown(): void {
        super.shutDown();
        this.player.off(this.type, this.beginState, this);
    }
}